<div class="currentPageIndicator appContainer">
  <div class="currentPageIndicator-wrapper">
    <a
      href="go-back"
      *ngIf="showBackButton"
      aria-label="go back"
      (click)="handleClick()"
    >
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </a>
    <h1>{{ currentPageTitle | i18next }}</h1>
  </div>
</div>
